<template>
  <div id="game-wrapper" :class="{start: bStartScreen}" @click="bStartScreen = false" @touchstart.self.prevent="bStartScreen = false">
    <img id="donkey" src="../src/assets/esel.png" alt="" />
    <img id="title" src="../src/assets/title.jpg" alt="" />
    <div id="question">
      <h1>
        <span>
          {{question.text}}
        </span>
      </h1>
      <ul>
        <li v-for="answer in question.answers" :key="answer.id" :data-answer-id="answer.id" @click="onAnswerClick(answer.id)" @touchstart.self.prevent="onAnswerClick(answer.id)" :class="{current: (answer.id == selectedAnswerId)}">
          <span>{{ answer.text }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div :class="{popup: true, show: (answer.id == selectedAnswerId)}" v-for="answer in question.answers" :key="answer.id" @click="selectedAnswerId = 0" @touchstart.self.prevent="selectedAnswerId = 0" v-html="answer.popup"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Multiple-Choice',
  data () {
    return {
      bStartScreen: true,
      selectedAnswerId: 0,
      question: {
        text: 'Pourquoi Jésus s’est-il rendu à Jérusalem sur le dos d’un âne ?',
        answers: [
          {
            id: 1,
            text: 'Il a raté le train !',
            popup: '<h2>Faux, désolé.</h2> <p>Eh oui, à l’époque où vivait Jésus, <br>il n’y avait pas encore de trains. <br>Tu as raté le coche – essaie encore une fois !</p>'
          },
          {
            id: 2,
            text: 'Son noble cheval s’était blessé.',
            popup: '<h2>Faux, désolé.</h2> <p>À l’époque, seuls les riches pouvaient s’offrir un noble cheval de selle. Et Jésus était pauvre. <br>Tu n’iras malheureusement nulle part avec ce cheval - essaie encore une fois !</p>'
          },
          {
            id: 3,
            text: 'L’âne était une bête de somme réservée aux gens du peuple.',
            popup: '<h2>Exact !</h2> <p>Avec son pelage gris plutôt quelconque, sa petite taille et son caractère parfois imprévisible, l’âne a depuis toujours été raillé et le terme d’âne utilisé comme insulte pour désigner les gens bêtes. <br>Jésus voulait montrer qu’il n’était pas un héros orgueilleux et riche, mais un homme comme tout le monde, simple et modeste.</p>'
          }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    onAnswerClick (id) {
      console.log('onAnswerClick()', id)
      this.selectedAnswerId = id
    }
  }
}
</script>
